var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('press-center',{attrs:{"in-category":2021,"current-url":"Russian sign language","in-name":"russian-sign-language"}})}
var staticRenderFns = []

export { render, staticRenderFns }